import { render, staticRenderFns } from "./Stakeholder.vue?vue&type=template&id=d5e5f86a&scoped=true&"
import script from "./Stakeholder.vue?vue&type=script&lang=js&"
export * from "./Stakeholder.vue?vue&type=script&lang=js&"
import style0 from "./Stakeholder.vue?vue&type=style&index=0&id=d5e5f86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e5f86a",
  null
  
)

export default component.exports